import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  settingContainer: {
    display: 'flex-start',
    flexDirection: 'column',
    paddingLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(0.5),
    width: theme.spacing(81.5)
  },
  title: {
    margin: theme.spacing(1.75, 0)
  },
  settingsContent: {
    marginTop: theme.spacing(2),
    alignContent: 'flex-start',
    display: 'flex',
    flexDirection: 'column'
  },
  saveButton: {
    justifyContent: 'start',
    display: 'flex',
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(0.5, 0)
  }
}));

export const CollectorManagePageSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.settingContainer}>
      <Typography className={classes.title}>
        <Skeleton height={40} width={'20%'} />
      </Typography>

      <div className={classes.settingsContent}>
        <Skeleton height={40} width={'90%'} />
      </div>

      <div className={classes.saveButton}>
        <Skeleton height={40} width={'10%'} />
      </div>
    </div>
  );
};
